import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchBuildings_buildingIdHeatingSettings = z.any()
export type TagsPatchBuildings_buildingIdHeatingSettings = z.infer<typeof tagsPatchBuildings_buildingIdHeatingSettings>

export const paramsPatchBuildings_buildingIdHeatingSettings = z.object({ "buildingId": z.string().uuid() })
export type ParamsPatchBuildings_buildingIdHeatingSettings = z.infer<typeof paramsPatchBuildings_buildingIdHeatingSettings>

export const bodyPatchBuildings_buildingIdHeatingSettings = z.object({ "stationId": z.union([z.string().min(1).max(64), z.null()]).optional(), "temperaturePeriod": z.object({ "from": z.string().date(), "to": z.union([z.string().date(), z.null()]), "temperatureC": z.number().gte(0).lte(40) }).optional(), "clearTemperaturePeriod": z.object({ "from": z.string().date(), "to": z.union([z.string().date(), z.null()]) }).optional(), "heatingSharePercent": z.number().gte(0).lte(100).optional(), "heatingRule": z.object({ "limitC": z.union([z.number().gte(-30).lte(40), z.null()]), "seasonOnly": z.boolean() }).optional() }).strict()
export type BodyPatchBuildings_buildingIdHeatingSettings = z.infer<typeof bodyPatchBuildings_buildingIdHeatingSettings>

export const responsePatchBuildings_buildingIdHeatingSettings = z.object({ "payload": z.object({ "saved": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchBuildings_buildingIdHeatingSettings = z.infer<typeof responsePatchBuildings_buildingIdHeatingSettings>

interface IPatchBuildings_buildingIdHeatingSettings extends BaseMethodType {
  tags: TagsPatchBuildings_buildingIdHeatingSettings,
  params: ParamsPatchBuildings_buildingIdHeatingSettings,
  body: BodyPatchBuildings_buildingIdHeatingSettings,
  response: ResponsePatchBuildings_buildingIdHeatingSettings
}
export const URL = '/buildings/:buildingId/heating/settings'
export const validation = {
  patch: {
    tags: tagsPatchBuildings_buildingIdHeatingSettings,
    params: paramsPatchBuildings_buildingIdHeatingSettings,
    body: bodyPatchBuildings_buildingIdHeatingSettings,
    response: responsePatchBuildings_buildingIdHeatingSettings
  }
}
export interface Buildings_buildingIdHeatingSettings extends BaseRouteType {
  patch: IPatchBuildings_buildingIdHeatingSettings
}